import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { useMemo, createElement } from 'react';
import 'prop-types';
import { u as useUtils } from './dimensions-bd426990.js';
import clsx from 'clsx';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import '@material-ui/core/IconButton';
import '@material-ui/core/Toolbar';
import '@material-ui/core/utils';
import { P as PickerToolbar } from './ClockView-03c73477.js';
import './ArrowSwitcher-b0a281b3.js';
import { makeStyles } from '@material-ui/core/styles';
import '@babel/runtime/helpers/esm/typeof';
import './utils-66277a98.js';
import { i as isYearOnlyView, b as isYearAndMonthViews, g as getFormatByViews } from './Calendar-afaf51ae.js';
import { m as makePickerWithStateAndWrapper, R as ResponsiveWrapper, M as MobileWrapper, D as DesktopWrapper, S as StaticWrapper, d as datePickerDefaultProps } from './Wrapper-4adf0bef.js';
import '@material-ui/core/useMediaQuery';
import '@material-ui/core/Button';
import '@material-ui/core/DialogActions';
import '@material-ui/core/DialogContent';
import '@material-ui/core/Dialog';
import '@material-ui/core/TextField';
import './Picker-2bbc7ba8.js';
import './WrapperVariantContext-747fba40.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@material-ui/core/InputAdornment';
import 'rifm';
import '@material-ui/core/Popover';
import '@material-ui/core/Grow';
import '@material-ui/core/Paper';
import '@material-ui/core/Modal/TrapFocus';
import '@material-ui/core/Popper';
import './useKeyDown-e9a6112c.js';
import './usePickerState-71de5ec1.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@babel/runtime/helpers/esm/inherits';
import './Clock-9baa7a72.js';
import '@material-ui/core/ButtonBase';
import '@material-ui/core/CircularProgress';
import 'react-transition-group';
import './Day.js';
import '@material-ui/core/Fade';

var useStyles = makeStyles({
  dateTitleLandscape: {
    margin: 'auto 16px auto auto'
  },
  penIcon: {
    position: 'relative',
    top: 4
  }
}, {
  name: 'MuiPickersDatePickerRoot'
});
var DatePickerToolbar = function DatePickerToolbar(_ref) {
  var date = _ref.date,
      views = _ref.views,
      isLandscape = _ref.isLandscape,
      isMobileKeyboardViewOpen = _ref.isMobileKeyboardViewOpen,
      toggleMobileKeyboardView = _ref.toggleMobileKeyboardView,
      toolbarFormat = _ref.toolbarFormat,
      _ref$toolbarTitle = _ref.toolbarTitle,
      toolbarTitle = _ref$toolbarTitle === void 0 ? 'SELECT DATE' : _ref$toolbarTitle;
  var utils = useUtils();
  var classes = useStyles();
  var dateText = useMemo(function () {
    if (toolbarFormat) {
      return utils.formatByString(date, toolbarFormat);
    }

    if (isYearOnlyView(views)) {
      return utils.format(date, 'year');
    }

    if (isYearAndMonthViews(views)) {
      return utils.format(date, 'month');
    } // Little localization hack (Google is doing the same for android native pickers):
    // For english localization it is convenient to include weekday into the date "Mon, Jun 1"
    // For other locales using strings like "June 1", without weekday


    return /en/.test(utils.getCurrentLocaleCode()) ? utils.format(date, 'normalDateWithWeekday') : utils.format(date, 'normalDate');
  }, [date, toolbarFormat, utils, views]);
  return createElement(PickerToolbar, {
    toolbarTitle: toolbarTitle,
    isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
    toggleMobileKeyboardView: toggleMobileKeyboardView,
    isLandscape: isLandscape,
    penIconClassName: classes.penIcon
  }, createElement(Typography, {
    variant: "h4",
    children: dateText,
    "data-mui-test": "datepicker-toolbar-date",
    align: isLandscape ? 'left' : 'center',
    className: clsx(isLandscape && classes.dateTitleLandscape)
  }));
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var datePickerConfig = {
  DefaultToolbarComponent: DatePickerToolbar,
  useDefaultProps: function useDefaultProps(_ref) {
    var _ref$openTo = _ref.openTo,
        openTo = _ref$openTo === void 0 ? 'date' : _ref$openTo,
        _ref$views = _ref.views,
        views = _ref$views === void 0 ? ['year', 'date'] : _ref$views;
    var utils = useUtils();
    return _objectSpread({}, datePickerDefaultProps, {
      views: views,
      openTo: openTo,
      mask: '__/__/____',
      inputFormat: getFormatByViews(views, utils)
    });
  }
};
var DatePicker = makePickerWithStateAndWrapper(ResponsiveWrapper, datePickerConfig);
var MobileDatePicker = makePickerWithStateAndWrapper(MobileWrapper, datePickerConfig);
var DesktopDatePicker = makePickerWithStateAndWrapper(DesktopWrapper, datePickerConfig);
var StaticDatePicker = makePickerWithStateAndWrapper(StaticWrapper, datePickerConfig);

export { DatePicker, DesktopDatePicker, MobileDatePicker, StaticDatePicker };
//# sourceMappingURL=DatePicker.js.map
